<template>
  <NotificationTemplate
    :notification="notification"
    :showSubTitle="false"
  >
    <template #pic>
      <div
        class="label-pic"
        :class="isPmReviewReminder ? 'is-review' : 'is-blue'"
      >
        <icon
          v-if="isPmReviewReminder"
          data="@icon/todo-review.svg"
          class="label-pic__icon"
          :fill="true"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
        <icon
          v-else
          data="@icon/list-unordered-v2.svg"
          class="label-pic__icon"
          width="var(--icon-24)"
          height="var(--icon-24)"
          color="#1565C0"
        />
      </div>
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
      >
        <template v-if="isPmReviewReminder">
          Just a reminder, you have Item awaiting PM Review
        </template>
        <template v-else>
          Just a reminder, these ToDo(s) are
          <span style="color: var(--serviceAlert-02)">due soon</span>
        </template>
      </BaseSubHeading>
    </template>
    <template #content>
      <ul class="notification__todo-reminder-list">
        <li
          v-for="(todo, index) in notification?.content.dueSoonTodo"
          :key="index"
          class="notification__todo"
        >
          <BaseSubHeading
            v-if="!todo.relatedUrl && !todo.url"
            v-ticket="{ wholeLink: true, todo: notification.getProjectId(todo) }"
            size="medium"
            color="monochrome-06"
            darkColor="monochrome-03"
            weight="400"
            className="notification__todo-item"
          >
            <ReferencedText
              :resetStyle="true"
              :html="notification.getTodoName(todo) || $t('none')"
            />
          </BaseSubHeading>

          <BaseSubHeading
            v-else
            size="medium"
            color="monochrome-06"
            darkColor="monochrome-03"
            weight="400"
            className="notification__todo-item"
          >
            <a
              target="_blank"
              :href="todo.url || todo.relatedUrl"
            >
              <ReferencedText
                :resetStyle="true"
                :html="notification.getTodoName(todo) || $t('none')"
              />
            </a>
          </BaseSubHeading>

          <icon
            v-if="todo.urgent"
            data="@icon/flag.svg"
            :fill="true"
            width="14"
            height="14"
            class="notification__todo-icon"
            color="#D32F2F"
          />
        </li>
      </ul>

      <BaseSubHeading
        v-if="notification?.content.hasMore"
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
        className="notification__todo-see-all"
      >
        There are more!
        <router-link
          v-if="$route.params.accountId"
          class="notification__todo-see-all-link"
          replace
          :to="{ query: { ...$route.query, toDo: 'true' } }"
        >
          See All
        </router-link>
      </BaseSubHeading>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"
import { ReferencedText } from "@/components/Reference"

import { ticket } from "@/directives"
import { NotificationTodo } from "@/models/Notification/NotificationTodo"

@Options({
  name: "TODO_REMINDER",
  components: {
    NotificationTemplate,
    ReferencedText
  },
  directives: {
    ticket
  }
})
export default class TODO_REMINDER extends Vue {
  @Prop() readonly notification: NotificationTodo

  /** The legacy reminder payload has no ToDo type, so infer PM review from its generated name. */
  get isPmReviewReminder() {
    return this.notification?.content.dueSoonTodo?.some(todo =>
      todo.name?.includes("PM Review requested by")
    )
  }
}
</script>
